import { Label } from "./ui/label";

export function Field({ label, required, highlight, children }) {
  return (
    <div>
      <Label className="overline-label">
        {label}{required && <span className="text-red-500 ml-0.5" title="Required">*</span>}
      </Label>
      <div className={`mt-1 rounded-sm ${highlight ? "ring-1 ring-amber-400 ring-offset-1 ring-offset-card" : ""}`}>{children}</div>
    </div>
  );
}

export function ReadOnly({ value }) {
  return <div className="h-9 flex items-center px-3 border border-border bg-secondary/40 text-sm rounded-sm text-muted-foreground">{value || "—"}</div>;
}

export function RibbonBtn({ icon: Icon, label, onClick, disabled, primary, testid }) {
  return (
    <button
      onClick={onClick} disabled={disabled} data-testid={testid}
      className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-sm text-xs font-semibold transition-colors disabled:opacity-40 ${
        primary ? "bg-primary text-primary-foreground hover:bg-primary/90" : "text-foreground hover:bg-secondary"
      }`}
    >
      <Icon size={15} weight="bold" /> {label}
    </button>
  );
}

export function PaneRow({ label, value, mono, tabular, bold }) {
  return (
    <div className="flex items-center justify-between gap-3">
      <span className="text-muted-foreground text-xs uppercase tracking-wide">{label}</span>
      <span className={`${mono ? "font-mono text-xs" : ""} ${tabular ? "tabular" : ""} ${bold ? "font-bold text-primary" : "font-medium"}`}>{value}</span>
    </div>
  );
}

// Small inline badge marking a document's transaction currency (hidden when blank).
export function CurrencyBadge({ currency }) {
  if (!currency) return null;
  const isAud = String(currency).toUpperCase() === "AUD";
  return (
    <span
      data-testid="currency-badge"
      title={`Currency: ${currency}`}
      className={`inline-flex items-center rounded-sm px-1.5 py-0.5 text-[10px] font-semibold leading-none tracking-wide border ${
        isAud ? "bg-secondary text-muted-foreground border-border" : "bg-primary/10 text-primary border-primary/30"
      }`}
    >
      {String(currency).toUpperCase()}
    </span>
  );
}

